import { render, staticRenderFns } from "./ColorPreview.vue?vue&type=template&id=0b2489c8&"
import script from "./ColorPreview.vue?vue&type=script&lang=js&"
export * from "./ColorPreview.vue?vue&type=script&lang=js&"
import style0 from "./ColorPreview.vue?vue&type=style&index=0&id=0b2489c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports